import { ChangeDetectionStrategy, Component, computed, input, linkedSignal, output } from '@angular/core';
import { IVehicleConvertibleSeat } from 'src/app/models';
import { LiteralService } from 'src/app/services';
import { TooltipPosition } from 'src/app/shared/tooltip/tooltip-position';
import { images } from 'src/images';

import { CommonModule } from '@angular/common';
import { TooltipModule } from '../../tooltip/tooltip.module';
@Component({
  selector: 'app-convertible-seats-input',
  templateUrl: './convertible-seats-input.component.html',
  imports: [CommonModule, TooltipModule],
  styleUrl: './convertible-seats-input.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ConvertibleSeatsInputComponent {
  readonly value = input<IVehicleConvertibleSeat[]>([]);
  readonly disabled = input(false);
  readonly min = input(0);
  readonly max = input<number>(99);
  readonly edit = input<boolean>(true);

  readonly changeEventEmitter = output<any>();

  public images = images;
  public TooltipPosition = TooltipPosition;
  public seats = linkedSignal(() => {
    const value = this.value();
    return Array.isArray(value) ? value.map((seat) => this.clamp(seat.numberOfRegularSeats)) : [];
  });
  public editable = computed(() => this.edit() && !this.disabled());

  constructor(
    public literalService: LiteralService
  ) {}

  public change(index: number, target: HTMLInputElement) {
    this.update(this.seats().map((seat, position) => (position === index ? this.clamp(target.value) : seat)));
    // the field keeps whatever was typed, so the clamped value has to be written back onto it
    target.value = String(this.seats()[index]?.numberOfRegularSeats ?? this.min());
  }

  addConvertibleSeat() {
    this.update([...this.seats(), this.clamp(this.min())]);
  }

  removeConvertibleSeat(index: number) {
    this.update(this.seats().filter((_, position) => position !== index));
  }

  private update(seats: IVehicleConvertibleSeat[]) {
    if (!this.editable()) return;
    this.seats.set(seats);
    this.changeEventEmitter.emit({ target: { value: seats } });
  }

  private clamp(value?: number | string): IVehicleConvertibleSeat {
    const seats = Math.floor(Number(value));
    const max = this.max();
    const capped = isNaN(seats) ? this.min() : (max !== undefined ? Math.min(seats, max) : seats);
    return { numberOfRegularSeats: Math.max(capped, this.min()) };
  }
}
